import type {
    BusinessProductDetails,
    MenuItemDetails,
    Product,
} from '@barboxx/models/types';

export function getMenuItemName(menuItem: MenuItemDetails) {
    switch (menuItem.type) {
        case 'StandardDrink':
            if (menuItem.standardDrink.isShot) {
                return `${menuItem.standardDrink.name} (Shot)`;
            }
            return menuItem.standardDrink.name;

        case 'CustomDrink':
            if (menuItem.customDrink.isShot) {
                return `${menuItem.customDrink.name} (Shot)`;
            }
            return menuItem.customDrink.name;
        case 'Product':
            return getProductName(menuItem.product);
    }
}

export function getProductName(product: Product | BusinessProductDetails) {
    const { brand, productLine, name } = product;

    const brandNameMatchesName =
        !!brand?.name && name.toLowerCase().includes(brand.name.toLowerCase());

    if (productLine && brand && !brandNameMatchesName) {
        return `${brand.name} ${productLine.name} - ${name}`;
    }

    if (productLine) {
        return `${productLine.name} - ${name}`;
    }

    if (brand && !brandNameMatchesName) {
        return `${brand.name} - ${name}`;
    }

    return name;
}
